import { httpRequest } from "@utils/HttpRequest";
import {
    IPage,
} from "@src/types/FmsTypes";
import { IMdSetting, IMdSettingFields, IMdSettingSearch } from "./SettingTypes";



class SettingService {
    /**
     * 新增系统配置
     * @param params 
     * @returns 
     */
    async insert(params: IMdSettingFields) {
        const settingInsertUrl = "/setting/insert";
        let ret = await httpRequest.post<IMdSetting>(settingInsertUrl, params);
        return ret;
    }
    /**
     * 启停配置
     * @param params 
     * @returns 
     */
    async disable(params: IMdSettingFields) {
        const settingDisableUrl = "/setting/disable";
        let ret = await httpRequest.post<boolean>(settingDisableUrl, params);
        return ret;
    }

    /**
     * 查询系统配置
     * @param params 
     * @returns 
     */
    async find(params: IMdSettingFields) {
        const settingPageUrl = "/setting/find";
        return await httpRequest.post<IMdSetting[]>(settingPageUrl, params);
    }

    /**
     * 获取系统配置列表
     * @param params 
     * @returns 
     */
    async settingDs(params: IMdSettingFields) {
        let { retData } = await this.find(params);
        return retData.map(el => ({
            label: el.code ?? "",
            value: el.value ?? ""
        }))
    }

    /**
     * 分页查询系统配置
     * @param params 
     * @returns 
     */
    async page(params: IMdSettingSearch) {
        const settingPageUrl = "/setting/page";
        return await httpRequest.post<IPage<IMdSetting>>(settingPageUrl, params);
    }

    /**
     * 查询某一系统配置
     * @param params 
     * @returns 
     */
    async one(params: IMdSettingFields) {
        const settingDisableUrl = "/setting/one";
        return await httpRequest.post<IMdSetting>(settingDisableUrl, params);
    }

    /**
     * 同步系统配置
     * @param params 
     * @returns 
     */
    async sync(params: IMdSettingFields) {
        const settingPageUrl = "/setting/sync";
        params.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(settingPageUrl, params, {
            timeout: 15000
        });
    }

    async syncPage(params: IMdSettingSearch) {
        const settingPageUrl = "/setting/syncPage";
        params.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(settingPageUrl, params);
    }

    async syncOne(params: IMdSettingFields) {
        const settingPageUrl = "/setting/syncPage";
        return await httpRequest.post<boolean>(settingPageUrl, params);
    }
}

export const settingService = new SettingService();
export default settingService
